<script>
const nav = [
  {
    route: 'hyperion.client.show',
    icon: 'project',
    text: 'Overview'
  }, {
    route: 'hyperion.client.product',
    icon: 'qrcode',
    text: 'Product'
  },
  // {
  //   route: 'hyperion.client.balance_request',
  //   icon: 'dollar',
  //   text: 'Balance Request'
  // },
  {
    route: 'hyperion.client.mutation',
    icon: 'line-chart',
    text: 'Mutations'
  }, {
    route: 'hyperion.client.transaction',
    icon: 'barcode',
    text: 'Transactions'
  }, {
    route: 'hyperion.client.webhook',
    icon: 'pull-request',
    text: 'Webhook'
  }, {
    route: 'hyperion.client.attachment',
    icon: 'folder-open',
    text: 'Files'
  }, {
    route: 'hyperion.client.edit',
    icon: 'edit',
    text: 'Edit'
  }
]

export default {
  name: "client-nav",
  props: {
    current: {
      type: String,
      required: true
    },
    client: {
      type: String,
      required: true
    }
  },
  data: () => ({
    nav
  })
}
</script>

<template>
  <a-menu mode="horizontal" :selected-keys="[current]">
    <a-menu-item v-for="item in nav"  :key="item.route">
      <a :href="routeUri(item.route, { client_hash: client })">
        <a-icon :type="item.icon"/>
        {{ item.text }}
      </a>
    </a-menu-item>
  </a-menu>
</template>
